<!-- START: Mobile frame -->
<div class="mobile-border">
  <ng-content select="[frameTop]"></ng-content>

  <div class="mobile-screen">
    <ng-content></ng-content>
  </div>

  <ng-content select="[frameBottom]"></ng-content>
</div>
<!-- END: Mobile frame -->
